<template>
  <div class="row">
    <div class="col col-md-10 offset-md-1 text-center">
      
      <div class="d-flex justify-content-center">

        <Combo
              :itens="$global.sites_filtro_completo()"
              v-model="filtroSite"
              style="max-width:150px;margin-right:10px;display:none"
              v-if="retornaSite() !== 'Share' && retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
            />

        <DataFiltro :value="filtroData" @change="carregarItens()" @reload="carregarItens()" />

        <input
          class="form-control inputPesquisa"
          style="max-width:80%;margin-right:10px;display:none"
          type="text"
          placeholder="Email..."
          v-model="filtroUsuario"
          @keyup="keyupFiltroUsuario"
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          style="display:none"
          @click="carregarItens()"
        >Filtrar</button>
      </div>

      <hr />

      <div class="row" v-if="retornaSite() == '7live'">
        <div class="col col-6">

          <div class="card" style="margin-bottom:10px" v-for="itemUsuarioEvento in itensUsuarioEventos"
          :key="itemUsuarioEvento._id"
          :item="itemUsuarioEvento">
            <div class="card-body text-left">
              <h5 class="card-title" style="margin-bottom:0px"><small>{{itemUsuarioEvento.usuario.nome}}</small></h5>
              <div class="row">
                <div class="col col-12">
                  <p class="card-text" style="padding:0;margin:0;margin-bottom:5px"><small>Eventos {{formatDouble(itemUsuarioEvento.eventos)}} de {{formatDouble(totalEventos)}}</small></p>
                  <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="{width:((100 * itemUsuarioEvento.eventos) / totalEventos).toString() + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col col-6">
            
            <div class="card" style="margin-bottom:10px" v-for="itemUsuarioAssinante in itensUsuarioAssinantes"
          :key="itemUsuarioAssinante._id"
          :item="itemUsuarioAssinante">
              <div class="card-body text-left">
                <h5 class="card-title" style="margin-bottom:0px"><small>{{itemUsuarioAssinante.usuario.nome}}</small></h5>
                <div class="row">
                  <div class="col col-12">
                    <p class="card-text" style="padding:0;margin:0;margin-bottom:5px"><small>Assinantes {{formatDouble(itemUsuarioAssinante.assinantes)}} de {{formatDouble(totalAssinantes)}}</small></p>
                    <div class="progress">
                      <div class="progress-bar bg-warning" role="progressbar" v-bind:style="{width:((100 * itemUsuarioAssinante.assinantes) / totalAssinantes).toString() + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>

      <div class="rowLista">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div class="col">
              <h5 style="margin-top:9px">Evento</h5>
            </div>
            <div class="col col-md-3 text-center" style="max-width:150px" v-if="retornaSite() == '7live'">
              <h5 style="margin-top:9px">Bot</h5>
            </div>
            <div class="col col-md-3 text-center" style="max-width:150px">
              <h5 style="margin-top:9px">Assinantes</h5>
            </div>
          </div>
        </div>
        <div
          class="list-group-item list-group-item-action text-left"
          v-for="item in itens"
          :key="item.id"
          :item="item"
        >
          <div class="row">
            <div class="col">
              <h5 style="margin-top:9px">
                <small>
                  {{ item.evento[0].dataDia.toString().padStart(2, "0") }} / 
                  {{ item.evento[0].dataHora.toString().padStart(2, "0") }}:{{
                  item.evento[0].dataMinuto.toString().padStart(2, "0")
                  }}
                </small> - {{ item.evento[0].nome }}
              </h5>
            </div>
            <div class="col col-md-3 text-center" style="max-width:150px"  v-if="retornaSite() == '7live'">
              
              <h5 style="margin-top:9px"><small>{{ item.usuarioCriacao[0].nome }}</small></h5>
              
            </div>
            <div class="col col-md-3 text-center" style="max-width:150px">
              
              <h5 style="margin-top:9px"><small>{{ item.sessoesUsuarios }}</small></h5>
              
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";
import DataFiltro from "../components/DataFiltro.vue";
import util from "../includes/util.js";

export default {
  name: "ListSessaoViewHistorico",
  components: { Combo, DataFiltro },
  props: { itensLimit: { type: Number, default: 10000 } },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    async carregarItens() {
      var filtros = "";
      this.itens = [];
      this.itensEventos= [];
      this.itensEventosUsuario = {};
      this.itensUsuarioEventos = [];
      this.itensUsuarioAssinantes = [];
      this.totalAssinantes = 0;
      this.totalEventos = 0;

      if (this.filtroEvento !== "") {
        
        if (this.filtroUsuario !== "") {
          filtros += "&usuario=" + this.filtroUsuario;
        }

        if(this.filtroSite !== "Todos")
        {
          filtros += "&site=" + this.filtroSite;
        }

        filtros += "&data=" + this.filtroData.dia + "-" + this.filtroData.mes + "-" + this.filtroData.ano;

        filtros += "&_limit=" + this.itensLimit;

        const response = await api.get("/sessaoView/evento/historico?" + filtros);
        api.valid(response.data, this.$router);

        this.itens = response.data.itens;

        for(var indiceItem = 0; indiceItem < this.itens.length;indiceItem++)
        {

          var item = this.itens[indiceItem];

          if(item.usuarioCriacao.length > 0)
          {
            
            if(!this.itensEventosUsuario[item.usuarioCriacao[0]._id.toString()])
            {
              this.itensEventosUsuario[item.usuarioCriacao[0]._id] = {usuario: item.usuarioCriacao[0], eventos: 0, assinantes: 0};
            }

            this.itensEventosUsuario[item.usuarioCriacao[0]._id].eventos = this.itensEventosUsuario[item.usuarioCriacao[0]._id].eventos + 1;
            this.itensEventosUsuario[item.usuarioCriacao[0]._id].assinantes = this.itensEventosUsuario[item.usuarioCriacao[0]._id].assinantes + item.sessoesUsuarios;

          }

          this.totalAssinantes = this.totalAssinantes + item.sessoesUsuarios;
          this.totalEventos = this.totalEventos + 1;

        }

        this.itensUsuarioEventos = Object.values(this.itensEventosUsuario).sort((a, b) => b.eventos - a.eventos);
        this.itensUsuarioAssinantes = Object.values(this.itensEventosUsuario).sort((a, b) => b.assinantes - a.assinantes);

      }
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
    formatDouble(valor) {
      return util.formatDouble(valor);
    },
  },
  mounted() {

    var dataAtual = new Date();
    this.filtroData.dia = dataAtual.getDate();
    this.filtroData.mes = dataAtual.getMonth() + 1;
    this.filtroData.ano = dataAtual.getFullYear();

    this.carregarItens();
  },
  computed: {
    sessoesTotais: function () {
      return this.itens.reduce(function (a, b) {
        return a + b.total;
      }, 0);
    },
  },
  data: function () {
    return {
      itens: [],
      itensEventos: [],
      itensEventosUsuario:{},
      itensUsuarioEventos:[],
      itensUsuarioAssinantes:[],
      totalAssinantes:0,
      totalEventos:0,
      filtroSite:"Todos",
      filtroUsuario: "",
      filtroData:{dia:0,mes:0,ano:0},
      timerFiltroUsuario:null
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
